import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useAuthStore from '../store/authStore';
import BrandMark from '../components/BrandMark';

function IconMail({ className }) {
  return (
    <svg className={className} width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="2" y="4" width="20" height="16" rx="3" /><path d="m2 7 10 6 10-6" />
    </svg>
  );
}
function IconLock({ className }) {
  return (
    <svg className={className} width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="4" y="11" width="16" height="10" rx="2" /><path d="M8 11V7a4 4 0 0 1 8 0v4" />
    </svg>
  );
}
function IconEye({ off }) {
  return off ? (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 10 8 10 8a17.4 17.4 0 0 1-2.7 3.9M6.6 6.6C3.4 8.5 2 12 2 12s3 8 10 8a9.6 9.6 0 0 0 5.4-1.6" />
      <path d="M14.12 14.12A3 3 0 1 1 9.88 9.88" /><path d="M2 2l20 20" />
    </svg>
  ) : (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M2 12s3-8 10-8 10 8 10 8-3 8-10 8-10-8-10-8Z" /><circle cx="12" cy="12" r="3" />
    </svg>
  );
}

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPw, setShowPw] = useState(false);
  const { login, loading, error } = useAuthStore();
  const navigate = useNavigate();

  async function handleSubmit(e) {
    e.preventDefault();
    const ok = await login(email, password);
    if (ok) navigate('/');
    else setPassword('');
  }

  return (
    <div style={{
      minHeight: '100vh', background: 'var(--bg)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      position: 'relative', overflow: 'hidden',
    }}>
      {/* fondo ambiental: resplandores a la deriva */}
      <div className="sg-ambient">
        <span style={{
          top: '-18%', left: '50%', width: 560, height: 340,
          background: 'radial-gradient(ellipse at center, color-mix(in srgb, var(--red) 30%, transparent) 0%, transparent 70%)',
          animation: 'sg-drift 11s ease-in-out infinite',
        }} />
        <span style={{
          bottom: '-15%', right: '8%', width: 420, height: 300,
          background: 'radial-gradient(ellipse at center, color-mix(in srgb, var(--amber) 22%, transparent) 0%, transparent 70%)',
          animation: 'sg-drift-2 13s ease-in-out infinite',
        }} />
      </div>
      {/* grid background, desvanecida hacia los bordes para que no corte en seco */}
      <div className="sg-grid-fade" style={{
        position: 'fixed', inset: 0, pointerEvents: 'none',
        backgroundImage: 'linear-gradient(color-mix(in srgb, var(--border) 70%, transparent) 1px,transparent 1px),linear-gradient(90deg,color-mix(in srgb, var(--border) 70%, transparent) 1px,transparent 1px)',
        backgroundSize: '40px 40px',
        opacity: .5,
      }} />

      <div className="sg-page" style={{ position: 'relative', zIndex: 1, width: '100%', maxWidth: 400, padding: '0 20px' }}>

        {/* Logo — con vida: halo pulsante, flotación suave y brillo deslizante */}
        <div style={{ textAlign: 'center', marginBottom: 40 }}>
          <div className="sg-logo-tile" style={{ width: 84, height: 84, margin: '0 auto 18px' }}>
            <div className="sg-logo-halo" />
            <div className="sg-logo-sweep-mask" style={{ width: '100%', height: '100%', borderRadius: 20 }}>
              <BrandMark size={84} />
              <div className="sg-logo-sweep" />
            </div>
          </div>
          <div className="sg-grad-text" style={{ fontSize: 29, fontWeight: 900, letterSpacing: -.6, animation: 'sg-fade-up .5s var(--ease) .15s both' }}>
            SegAvan
          </div>
          <div style={{
            marginTop: 9, display: 'inline-block',
            fontSize: 9, fontWeight: 700, letterSpacing: '.16em', textTransform: 'uppercase',
            color: 'var(--text-dim)', background: 'var(--surface)',
            border: '1px solid var(--border)', borderRadius: 20, padding: '3px 14px',
            animation: 'sg-fade-up .5s var(--ease) .22s both',
          }}>
            Seguridad Avanzada y Proyectos
          </div>
        </div>

        {/* Form card */}
        <div className="sg-glass" style={{
          border: '1.5px solid var(--border)',
          borderRadius: 20, padding: 30,
          boxShadow: 'var(--shadow)',
          animation: 'sg-fade-up .45s var(--ease) .05s both',
        }}>
          <div style={{ fontSize: 13, fontWeight: 700, color: 'var(--text-dim)', marginBottom: 20, textTransform: 'uppercase', letterSpacing: '.08em' }}>
            Acceso al sistema
          </div>

          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom: 14, animation: 'sg-fade-up .4s var(--ease) .12s both' }}>
              <label className="sg-label">Email o usuario</label>
              <div className="sg-input-icon-wrap">
                <IconMail className="sg-input-icon" />
                <input
                  className="sg-input sg-input--icon"
                  type="text" required
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  placeholder="usuario@segavan.com"
                />
              </div>
            </div>

            <div style={{ marginBottom: 20, animation: 'sg-fade-up .4s var(--ease) .18s both' }}>
              <label className="sg-label">Contraseña</label>
              <div className="sg-input-icon-wrap">
                <IconLock className="sg-input-icon" />
                <input
                  className="sg-input sg-input--icon sg-input--suffix"
                  type={showPw ? 'text' : 'password'} required
                  value={password}
                  onChange={e => setPassword(e.target.value)}
                  placeholder="••••••••"
                />
                <button
                  type="button" className="sg-input-suffix-btn"
                  onClick={() => setShowPw(s => !s)}
                  aria-label={showPw ? 'Ocultar contraseña' : 'Mostrar contraseña'}
                  tabIndex={-1}
                >
                  <IconEye off={showPw} />
                </button>
              </div>
            </div>

            {error && (
              <div style={{
                background: 'color-mix(in srgb, var(--bad) 10%, transparent)',
                border: '1px solid color-mix(in srgb, var(--bad) 35%, transparent)',
                borderRadius: 7, padding: '9px 13px', marginBottom: 16,
                fontSize: 12, color: 'var(--bad)', fontWeight: 600,
                animation: 'sg-fade-up .2s var(--ease) both',
              }}>
                {error}
              </div>
            )}

            <button className="sg-btn-primary" type="submit" disabled={loading}
              style={{ width: '100%', animation: 'sg-fade-up .4s var(--ease) .24s both' }}>
              {loading ? 'Accediendo...' : 'Entrar →'}
            </button>
          </form>
        </div>

        <div style={{ textAlign: 'center', marginTop: 24, fontSize: 10, color: 'var(--text-dim)', opacity: .6, fontWeight: 600, letterSpacing: '.06em' }}>
          SegAvan © 2012 · v2.0.0
        </div>
      </div>
    </div>
  );
}
